import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Radio } from '@mui/material';
import login_logo2 from '../../../assets/images/login_logo2.png'
import './Login.css';
import { useState, useRef } from 'react';

import {useDispatch } from 'react-redux';
import { LOGIN_SUCCESS } from '../../../RTK/Slices/AuthSlice';
import { login_user_via_send_otp,login_user_via_verify_otp } from '../../../helper/Api';
import { toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";
import NoticeCircularModal from "./NoticeCircularModal";
import {
  RECAPTCHA_SITE_KEY,
  getApiErrorMessage,
  withCaptchaPayload,
  getCaptchaToken,
  resetCaptcha,
} from '../../../helper/captcha';

export default function Login() {
  const [error, setError] = React.useState(null);
  const [formData,setformData]=useState({
      "mobile":null,
      "user_type":null,
      'otp':''
  });
  const [captchaValue, setCaptchaValue] = useState('');
  const recaptchaRef = useRef(null);

  const [send_otp,setSend_otp]=useState(false);

  const dispatch=useDispatch();
  const handleChange = (event) => {
    const name=event.target.name;
    const value=event.target.value;
    setformData({...formData,[name]:value});
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();
    const captchaToken = getCaptchaToken(recaptchaRef, captchaValue);
    if (!captchaToken) {
      toast.error("Please complete the CAPTCHA", {
        position: toast.POSITION.TOP_CENTER
      });
      return;
    }
    try {
      if(send_otp){
        if(formData.mobile && formData.otp){
          const loginResponse=await login_user_via_verify_otp(
            withCaptchaPayload(formData, captchaToken)
          );
          if(loginResponse.data.status){
            toast.success(loginResponse.data.message,{
              position: toast.POSITION.TOP_CENTER
            });
            dispatch(LOGIN_SUCCESS(loginResponse.data));
            sessionStorage.setItem("is_loggedIn", true);
            sessionStorage.setItem("userDetails", loginResponse.data);
            window.location.href="/";
          }else{
            resetCaptcha(recaptchaRef, setCaptchaValue);
            toast.error(loginResponse.data.message,{
              position: toast.POSITION.TOP_CENTER
            });
          }
        }else{
          toast.error("All the field required",{
            position: toast.POSITION.TOP_CENTER
          });
        }
      }else{
        if(formData.mobile && formData.user_type){
          const loginResponse=await login_user_via_send_otp(
            withCaptchaPayload(formData, captchaToken)
          );
          if(loginResponse.data.status){
            setSend_otp(true)
            resetCaptcha(recaptchaRef, setCaptchaValue);
            toast.success(loginResponse.data.message,{
              position: toast.POSITION.TOP_CENTER
            });
            
          }else{
            resetCaptcha(recaptchaRef, setCaptchaValue);
            toast.error(loginResponse.data.message,{
              position: toast.POSITION.TOP_CENTER
            });
          }
        }else{
          toast.error("All the field required",{
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    } catch (err) {
      resetCaptcha(recaptchaRef, setCaptchaValue);
      toast.error(getApiErrorMessage(err), {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  return (
    <>
    <NoticeCircularModal />
    <Grid container component="div" sx={{ height: '100vh' }}>
    <CssBaseline />
    
    <Grid item xs={12} sm={12} md={12} component='div' className="login_bg_wrapper">
      <div component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent:"start",
            gap:"2rem"
          }}
        > 
          <img src={login_logo2} alt="login_logo" className='login_logo' />
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 1 }} onSubmit={handleSubmit} className='form_box'>
            <Typography component="p" variant="p" sx={{
                color: "red",
                fontWeight: "bold",
                paddingLeft: "10px",
                paddingTop:"10px",
                }}>
                  {error}
            </Typography>
            {send_otp ? 
              <TextField
              margin="normal"
              required
              fullWidth
              id="otp"
              label="OTP"
              type="number"
              name="otp"
              autoComplete="off"
              autoFocus
              onChange={handleChange}
              value={formData.otp}
            />
            :
            <TextField
              margin="normal"
              required
              fullWidth
              type="number"
              id="Mobile"
              label="Mobile"
              name="mobile"
              autoComplete="off"
              autoFocus
              onChange={handleChange}
              value={formData.mobile}
            />
            
            }
            <Box sx={{ my: 2 }}>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                ref={recaptchaRef}
                onChange={(value) => setCaptchaValue(value || '')}
                onExpired={() => resetCaptcha(recaptchaRef, setCaptchaValue)}
              />
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {send_otp?"VERIFY OTP":"GENERATE OTP"}
            </Button>
            <Grid container>
            </Grid>
            <Box sx={{ display: send_otp?'none':'flex', alignItems:'center', gap: 2 }}>
              <Radio
                checked={formData.user_type === 'l1'}
                onChange={handleChange}
                value="l1"
                name="user_type"
                
              >
              </Radio> L1
              <Radio
                checked={formData.user_type === 'l2'}
                onChange={handleChange}
                value="l2"
                name="user_type"
                label="Outlined"
                
              />
              L2
              <Radio
                checked={formData.user_type === 'l3'}
                onChange={handleChange}
                value="l3"
                name="user_type"
                label="Outlined"
                
              />
              L3
            </Box>
          </Box>
         <small> <b className='text-light'>Copyright &#169; 2023 TM, New Delhi. All Rights Reserved.</b></small>
        </Box>        
      </div>
      </Grid>
      </Grid>
    </>
  );
}
